// removed by extract-text-webpack-plugin
module.exports = {"base":"WGCWXLeaderboards_base--3x7vl","container":"WGCWXLeaderboards_container--2PJIw","infoContainer":"WGCWXLeaderboards_infoContainer--1Kr9L","info":"WGCWXLeaderboards_info--jv8aP","externalLink":"WGCWXLeaderboards_externalLink--1I3-m","mapButton":"WGCWXLeaderboards_mapButton--3KtBn","linksBlock":"WGCWXLeaderboards_linksBlock--37nQ4","boardsHolder":"WGCWXLeaderboards_boardsHolder--r4q1M","boards":"WGCWXLeaderboards_boards--2ClHN","boardItem":"WGCWXLeaderboards_boardItem--1NNuf"};


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/WGCWXLeaderboards.scss
// module id = 2483
// module chunks = 11